import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertService } from "../../services/alert.service";
import { ProductsService } from "../../services/products.service";

@Component({
    selector: "app-options-pricing",
    templateUrl: "./options-pricing.component.html",
    styleUrls: ["./options-pricing.component.scss"],
})
export class OptionsPricingComponent implements OnInit {
    @Input() supplierId;
    @Input() areActionButtonsHidden: boolean;
    @Output() exitStep = new EventEmitter();
    @Output() next = new EventEmitter();

    pricing = [];
    ranges = [];

    constructor(
        private productsService: ProductsService,
        private alertService: AlertService
    ) {}

    ngOnInit(): void {
        this.getSupplierPricing();
    }

    getSupplierPricing() {
        this.productsService
            .getSupplierOptionsPricing(this.supplierId)
            .subscribe((data) => {
                this.pricing = data.data;
                this.selectTab(this.pricing[0]);
            });
    }

    setSupplierPricing() {
        this.productsService
            .setSupplierOptionsPricing(this.pricing, this.supplierId)
            .subscribe((data) => {
                this.next.emit();
            });
    }

    addRangeRow(o) {
        const newCostItem = {
            ProductVariableSlug: "Height",
            company: this.supplierId,
            cost: 0,
            rangeMin: 0,
            rangeMax: 9999,
            skuId: o.skuId,
        };
        if (o.costs.length) {
            newCostItem.rangeMin = +o.costs[o.costs.length - 1].rangeMax + 1;
        }
        o.costs.push(newCostItem);
    }

    removeRangeRow(o, idx) {
        o.costs.splice(idx, 1);
        if (!o.costs.length) {
            o.enabled = false;
        }
    }

    toggleEnabled(o) {
        if (!o.enabled) {
            o.enabled = true;
            if (!o.costs.length) {
                this.addRangeRow(o);
            }
        } else {
            o.enabled = false;
            if (o.costs.length >= 1) {
                o.costs = [];
            }
        }
    }

    selectTab(p) {
        this.pricing.forEach((x) => (x.active = false));
        if (!p.active) {
            p.active = true;
        } else {
            p.active = false;
        }
    }
}
